// src/services/ProjectService.js
import api from "@/services/api";
import authHeader from "./authHeader";

export const projectService = {
  async fetchAllProjects() {
    return await api.get("/projects", { headers: authHeader() });
  },
  fetchProject(id) {
    return api.get(`/projects/${id}`, { headers: authHeader() });
  },
  fetchCreateProject(data) {
    return api.post("/projects", data, { headers: authHeader() });
  },
  fetchUpdateProject(id, data) {
    return api.put(`/projects/${id}`, data, { headers: authHeader() });
  },
  fetchDeleteProject(id) {
    return api.delete(`/projects/${id}`, { headers: authHeader() });
  },
};

export default projectService;
